import type React from 'react';

/** IME confirmation and held keys must never submit a chat draft. */
export const isComposerSendKey = (event: React.KeyboardEvent): boolean => (
  event.key === 'Enter' && !event.shiftKey && !event.nativeEvent.isComposing
  && event.nativeEvent.keyCode !== 229 && !event.repeat
);
